/**
 * SpeedFly V6 — Wishlist System
 * Stores wishlist product handles in localStorage.
 * Emits custom events for UI updates.
 * Zero external dependencies.
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'speedfly:wishlist';

  const Wishlist = {
    _items: [],

    init() {
      try {
        this._items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch(e) {
        this._items = [];
      }
      this._updateBadges();
      this._bindButtons();
    },

    getItems() {
      return [...this._items];
    },

    has(handle) {
      return this._items.indexOf(handle) !== -1;
    },

    toggle(handle) {
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      } else {
        this.add(handle);
        return true;
      }
    },

    add(handle) {
      if (!this.has(handle)) {
        this._items.unshift(handle);
        this._save();
        this._dispatch('wishlist:add', { handle });
      }
    },

    remove(handle) {
      this._items = this._items.filter(function(h) { return h !== handle; });
      this._save();
      this._dispatch('wishlist:remove', { handle });
    },

    count() {
      return this._items.length;
    },

    _save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this._items));
      } catch(e) {}
      this._updateBadges();
    },

    _updateBadges() {
      const badges = document.querySelectorAll('[data-wishlist-count]');
      const count = this.count();
      badges.forEach(function(badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      });

      /* Update all toggle buttons */
      const buttons = document.querySelectorAll('[data-wishlist-toggle]');
      const self = this;
      buttons.forEach(function(btn) {
        const handle = btn.dataset.wishlistToggle;
        btn.classList.toggle('is-wishlisted', self.has(handle));
        btn.setAttribute('aria-pressed', self.has(handle));
      });
    },

    _bindButtons() {
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.wishlistToggle;
        if (handle) {
          Wishlist.toggle(handle);
        }
      });
    },

    _dispatch(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }
  };

  /* Initialize on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { Wishlist.init(); });
  } else {
    Wishlist.init();
  }

  window.SpeedFly = window.SpeedFly || {};
  window.SpeedFly.wishlist = Wishlist;
})();
